import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAllOpenExchangeReceipts } from 'src/store/slices/generalMonitoringSlice';
import { ChartSkeleton, ColumnChart, MonitorCard, formatNumber } from 'src/components/monitoring/MonitoringParts';

// Değişim tarihine göre açık değişimlerin gün aralıklarına dağılımı
function OpenExchangeReceiptsWithDaysRangeChart() {
  const dispatch = useDispatch();
  const [mainData, setMainData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    setLoading(true);
    dispatch(getAllOpenExchangeReceipts())
      .then((response) => {
        setMainData(Array.isArray(response.payload) ? response.payload : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const items = mainData.map((item) => ({ label: item.DayRange, value: item.RecordCount }));
  const total = items.reduce((s, i) => s + (Number(i.value) || 0), 0);

  return (
    <MonitorCard
      title="Değişim Tarihine Göre Açık Değişimler"
      subtitle={loading ? 'Yükleniyor…' : `Gün aralıklarına dağılım · toplam ${formatNumber(total)} fiş`}
    >
      {loading ? <ChartSkeleton height={280} /> : <ColumnChart items={items} height={280} />}
    </MonitorCard>
  );
}

export default OpenExchangeReceiptsWithDaysRangeChart;
